import FetchError from "logic/errors/FetchError";
import translateApiError from "util/translateApiError";
export const extractErrorMessage = (error) => {
  var _a, _b;
  if (error instanceof FetchError) {
    return (_b = (_a = translateApiError(error)) != null ? _a : error.responseMessage) != null ? _b : error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return String(error);
};
export default extractErrorMessage;
